export default "__VITE_ASSET__CYbJ5tgD__"